<template>
  <div class="customer-detail">
    <div class="header">
      <h1 class="comp-name">{{ info.customerName }}</h1>
      <el-button v-if="editable" type="primary" @click="editDetail">编辑</el-button>
    </div>
    <div class="info-wrap">
      <div class="info-item" v-for="item in infoItems" :key="item.prop">
        <span class="item-label">{{ item.label }}</span>
        <span class="item-value">{{ info[item.prop] }}</span>
      </div>
    </div>
    <el-tabs class="tab-content" v-model="activeInfo" @tab-click="tabChange">
      <el-tab-pane label="跟进记录" name="follow">
        <customer-detail-follow :info="info" :editable="editable" @saveFollow="getDetailInfo" />
      </el-tab-pane>
      <el-tab-pane label="客户动态" name="dynamic" lazy>
        <detail-dynamic :id="customerId" :getLogs="getDynamicLogs"></detail-dynamic>
      </el-tab-pane>
      <el-tab-pane label="联系人" name="linkman" lazy>
        <link-manage :customer="info" :editable="editable" @saveLink="getDetailInfo"></link-manage>
      </el-tab-pane>
      <el-tab-pane label="详细资料" name="details" lazy>
        <customer-detail-info :info="info"></customer-detail-info>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CustomerDetailFollow from "./customer-detail-follow";
import DetailDynamic from "@/views/components/detail-dynamic";
import LinkManage from "@/views/components/link-manage";
import CustomerDetailInfo from "./customer-detail-info";
import { CustomerApis } from "@/apis";

export default {
  name: "customer-detail",
  data() {
    return {
      editable: this.$route.query.editable !== "false",
      customerId: this.$route.query.id,
      info: {},
      infoItems: [
        { label: "客户级别", prop: "customerLevelName" },
        { label: "跟进状态", prop: "followupStateName" },
        { label: "负责人", prop: "chargeName" },
        { label: "首要联系人", prop: "chiefName" },
        { label: "首要联系人电话", prop: "chiefPhone" },
      ],
      activeInfo: "follow",
      getDynamicLogs: CustomerApis.getCustDynamicLogs,
    };
  },
  created() {
    this.getDetailInfo();
  },
  methods: {
    getDetailInfo() {
      CustomerApis.getCustDataById(this.customerId).then((res) => {
        const chief = res.linkUserList && res.linkUserList.find((i) => i.isChief);
        this.info = res;
        if (chief) {
          this.info.chiefName = chief.linkName;
          this.info.chiefPhone = chief.linkPhone;
        }
      });
    },
    editDetail() {
      this.$router.push(`add-customer?id=${this.info.id}`);
    },
    tabChange(type) {
      // console.log(type);
    },
  },
  components: { CustomerDetailFollow, LinkManage, CustomerDetailInfo, DetailDynamic },
};
</script>

<style scoped lang="scss">
.customer-detail {
  flex-direction: column;
  overflow: auto;
}
.header {
  display: flex;
  align-items: center;
  .comp-name {
    flex: 1;
    line-height: 1;
    font-size: 20px;
    font-weight: bold;
  }
}
.info-wrap {
  padding: 20px 30px;
  background-color: #eff6ff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 15px 0;
  .info-item {
    line-height: 1;
  }
  .item-value {
    display: inline-block;
    padding-left: 16px;
    font-weight: bold;
  }
}
</style>
